<template>
  <a-modal
    v-model:visible="modalVisible"
    :footer="null"
    destroyOnClose
    title="Forgot Password"
    :maskClosable="false"
  >
    <p v-if="!recoveryAvailable" role="status">
      Please contact Allume support to restore access to your account.
    </p>
    <a-form
      v-else
      @finish="handleForgetPassword"
      layout="vertical"
      :model="forgetForm"
      :rules="rules"
    >
      <a-form-item name="email" label="Please input your Email" validateFirst>
        <a-input
          v-model:value="forgetForm.email"
          size="large"
          placeholder="Email"
          autocomplete="username"
        />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" html-type="submit" :loading="isLoading"> Submit </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { validateEmailAddress } from '@/utils/validators';
import { usePasswordRecovery } from '@/shared/auth/usePasswordRecovery';

export default {
  name: 'ForgetPasswordModal',
  props: {
    visible: Boolean,
  },
  setup() {
    return { recoveryAvailable: usePasswordRecovery() };
  },
  data() {
    return {
      isLoading: false,
      forgetForm: {
        email: '',
      },
      rules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          {
            validator: validateEmailAddress,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    async handleForgetPassword() {
      if (!this.recoveryAvailable || this.isLoading) return;
      this.isLoading = true;
      try {
        await this.$http.post(this.$api.forgetPassword, {
          email: this.forgetForm.email,
        });
        this.$message.success(
          'If your account can be recovered, you will receive an email with further instructions.',
        );

        this.modalVisible = false;
        this.forgetForm.email = '';
      } catch (e) {
        this.$message.error(e);
      }
      this.isLoading = false;
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit('update:visible', visible);
      },
    },
  },
};
</script>

<style scoped></style>
